import {
  DataObjectGroupProcessingStateType,
  registerTableFilter,
} from '@atlas-frontend/sdk';
import { type ColumnFilter, FilterFn } from '@tanstack/react-table';
import { InputGroupDescriptionFilterInput } from '../InputGroupDescriptionFilterInput';

declare module '@tanstack/react-table' {
  interface FilterFns {
    inputSampleSelect: FilterFn<any>;
    valueDateSelect: FilterFn<any>;
  }
}

registerTableFilter<DataObjectGroupProcessingStateType>(
  'inputSampleSelect',
  () => true, // Server-side filtering
  InputGroupDescriptionFilterInput,
);

export function hasInvalidFilter(filters: ColumnFilter[]): [boolean, number] {
  const index = filters.findIndex(({ id }) => id === 'isInvalid');
  if (index === -1) {
    return [false, index];
  }

  return [!!filters[index].value, index];
}

export function toggleInvalidFilter(filters: ColumnFilter[]) {
  const [value, index] = hasInvalidFilter(filters);
  if (index == -1) {
    return [...filters, { id: 'isInvalid', value: true }];
  }

  const newFilters = [...filters];
  if (value) {
    newFilters.splice(index, 1);
  } else {
    newFilters.splice(index, 1, { id: 'isInvalid', value: true });
  }

  return newFilters;
}
